"use client";
import {useTranslations} from "next-intl";

function Privacy() {
    // const seo = seoData['privacy-policy']
    const t = useTranslations("privacy");

    return (
        <>
            <section className="bg-pink mt-4">
                <div className="max-w-[800px] mx-auto py-[35px] px-[20px]">
                    <h1 className="text-[44px] text-center font-bold mb-2 whitespace-normal">{t("title")}</h1>
                    <p className="text-gray-600 text-center mb-[35px]">{t("lastUpdated")}</p>

                    <div
                        className="text-[16px] space-y-[30px]"
                        dangerouslySetInnerHTML={{ __html: t.raw("content") }}
                    />
                </div>
            </section>
        </>
    )
}

export default Privacy